<template>
  <div class="_mainOr">
    <el-table
      :data="organizationData"
      border
      :header-cell-style="{ background: '#87baf9', color: '#f2f2f2' }"
      height="100%"
      style="padding: 0"
    >
      <el-table-column label="组织部门" align="left" width="300">
        <template slot-scope="scope">
          <span
            :style="{ paddingLeft: scope.row.level * 20 + 'px' }"
            class="_imgDiv"
          >
            <img
              v-if="scope.row.level == 0"
              src="@/assets/pImg/szqy.png"
              alt=""
              class="_img"
            />
            <img v-else src="@/assets/pImg/dept.svg" alt="" class="_img" />
            {{ scope.row.name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="responsiblePerson" label="部门负责人" width="200">
        <template slot-scope="scope">
          <!-- <span v-if="scope.row.managerList.length != 0">{{ scope.row.managerList.join(',') }}</span> -->
          <span v-if="scope.row.managerList.length != 0">{{
            getChargeMan(scope.row.managerList)
          }}</span>
          <span v-else>暂无</span>
        </template>
      </el-table-column>
      <el-table-column prop="personNum" label="在职人数" width="200">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="medium"
            style="margin-right: 20px"
            @click="addFunc(scope.row)"
            >新增子部门</el-button
          >
          <el-button type="text" size="medium" @click="editFunc(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" size="medium" @click="deleteFunc(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisible"
      width="30%"
      class="centered-dialog"
      align-center
    >
      <el-form label-width="100px">
        <el-form-item label="上级部门：">
          <span style="font-size: 17px">{{ lastLevelInfo }}</span>
        </el-form-item>
        <el-form-item label="部门名称：">
          <el-input
            v-model="deptName"
            placeholder="限10个汉字"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="outMark">编外人员</el-checkbox>
        </el-form-item>
        <el-form-item label="负责人：" v-show="!outMark">
          <!-- <el-input v-model="chargeMan" placeholder="可选多人，模糊查询"></el-input> -->
          <el-select
            v-model="dialogManagerList"
            placeholder="请选择负责人、可多选"
            style="width: 100%"
            multiple
          >
            <el-option
              v-for="item in chargeManData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="ensureBtnFunc()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOrganizationList } from '@/api/pServer/staff';
import {
  getEmployee,
  addNewDept,
  updateDept,
  deleteDept,
} from '@/api/pServer/organizationStructure';
export default {
  data() {
    return {
      outMark: false,
      dialogVisible: false,
      dialogName: '',
      lastLevelInfo: '',
      dialogLevel: '',
      deptName: '',
      editId: '',
      dialogManagerList: [],
      chargeManData: [],
      treeData: [],
      organizationData: [],
    };
  },
  created() {
    this.getOrganizationList();
    this.getEmployee();
  },
  watch: {
    checked(newValue) {
      this.outMark = newValue;
    },
  },
  methods: {
    async getOrganizationList() {
      this.organizationData = [];
      this.treeData = [];
      const res = await getOrganizationList();
      this.treeData.push(res.data.data);
      this.flattenData(this.treeData);
    },
    async getEmployee() {
      const res = await getEmployee();
      this.chargeManData = res.data.data;
    },

    flattenData(data, level = 0) {
      data.forEach((item) => {
        this.organizationData.push({ ...item, level });
        if (item.childDeptDto) {
          this.flattenData(item.childDeptDto, level + 1);
        }
      });
    },
    getChargeMan(data) {
      if (data.length == 1) {
        return data[0].managerName;
      } else {
        var lastManageData = [];
        data.forEach((item) => {
          lastManageData.push(item.managerName);
        });
        return lastManageData.join(',');
      }
    },
    addFunc(data) {
      this.dialogVisible = true;
      this.dialogName = '新增子部门';
      this.lastLevelInfo = data.name;
      this.dialogLevel = data.level;
      this.dialogManagerList = [];
      this.outMark = false;
      this.deptName = '';
      this.editId = data.id;
    },
    editFunc(data) {
      this.dialogVisible = true;
      this.dialogManagerList = [];
      this.dialogName = '编辑子部门';
      this.editId = data.id;
      //通过parantId 查id
      this.lastLevelInfo = '';
      if (data.level == 0) {
        this.lastLevelInfo = data.name;
      } else {
        this.organizationData.forEach((item) => {
          if (item.id == data.parentId) {
            this.lastLevelInfo = item.name;
            return;
          }
        });
      }
      data.managerList.forEach((data) => {
        this.dialogManagerList.push(data.managerId);
      });
      this.outMark = data.outMark == 1;
      this.deptName = data.name;
      this.dialogLevel = data.level;
    },

    deleteFunc(row) {
      this.$confirm('确定删除该部门？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteDept(row);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },

    async deleteDept(row) {
      const { data } = await deleteDept({ id: row.id });

      if (data.code == 200) {
        this.$message.success('操作成功');
        this.getOrganizationList();
      } else {
        this.$message.error(data.message);
      }
    },

    ensureBtnFunc() {
      if (
        this.deptName.length == 0 ||
        (this.dialogManagerList.length == 0 && !this.outMark)
      ) {
        this.$message.error('请完善信息！');
        return;
      }
      var lastManageList = [];
      this.dialogManagerList.forEach((data) => {
        this.chargeManData.forEach((item) => {
          if (item.id == data) {
            lastManageList.push({ managerId: item.id, managerName: item.name });
          }
        });
      });
      var params = {
        level: this.dialogLevel,
        managerList: this.outMark ? [] : lastManageList,
        name: this.deptName,
        outMark: this.outMark ? '1' : '0',
        id: this.editId,
      };
      // console.log("入参", params);
      if (this.dialogName.includes('新增')) {
        this.addNewDept(params);
      } else {
        this.updateDept(params);
      }
    },
    async addNewDept(params) {
      delete params.id;
      params.parentId = this.editId;
      const res = await addNewDept(params);
      if (res.data.code == 200) {
        this.dialogVisible = false;
        this.getOrganizationList();
        this.$message.success(res.data.message);
      } else {
        this.$message.error(res.data.message);
      }
    },
    async updateDept(params) {
      const res = await updateDept(params);
      // console.log("返回", res);
      if (res.data.code == 200) {
        this.dialogVisible = false;
        this.getOrganizationList();
        this.$message.success(res.data.message);
      } else {
        this.$message.error(res.data.message);
      }
    },
  },
};
</script>

<style scoped>
._main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
  overflow-y: auto;
}

._imgDiv {
  height: 30px;
  display: flex;
  align-items: center;
}

._img {
  height: 15px;
  width: 15px;
  padding: 10px;
}
</style>

<style>
._mainOr {
  .el-form-item {
    margin-bottom: 0px;
  }
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  text-align: center;
}
.el-table td.el-table__cell {
  padding: 4px 0;
}
</style>
